import { fetchWithToken } from "../../../interceptors/fetchInterceptor";

import { getAllBoatTypes } from "../../actions";

import {
  API_CREATE_BOAT_TYPE,
  API_GET_BOAT_TYPE_BY_ID,
  API_UPDATE_BOAT_TYPE_BY_ID,
  MAIN_URL,
  PORT_FOR_AUTH,
} from "../../../constants/constants";
import { GET_BOAT_TYPE_BY_ID } from "../../types";

export const getBoatType = (id) => {
  return async (dispatch) => {
    const response = await fetchWithToken(
      MAIN_URL + PORT_FOR_AUTH + API_GET_BOAT_TYPE_BY_ID + id,
    );
    if (response.status === 200) {
      const data = await response.json();

      dispatch({
        type: GET_BOAT_TYPE_BY_ID,
        data: data,
      });
    }
  };
};
export const updateBoatType = (id, data) => {
  return async (dispatch) => {
    const response = await fetchWithToken(
      MAIN_URL + PORT_FOR_AUTH + API_UPDATE_BOAT_TYPE_BY_ID + id,
      {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    dispatch(getAllBoatTypes());
  };
};
export const createBoatType = (data) => {
  return async (dispatch) => {
    const response = await fetchWithToken(
      MAIN_URL + PORT_FOR_AUTH + API_CREATE_BOAT_TYPE,
      {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    dispatch(getAllBoatTypes());
  };
};
